import {
  AUTH_LOGIN,
  AUTH_LOGOUT,
  CLEAR_MODULE_STATE,
  UPDATE_ADMIN_ROLE, UPDATE_DEBUG_VIEW, UPDATE_MANAGER_RESTRICTED,
  UPDATE_USER_PROFILE,
  UPDATE_USER_ROLE
} from '../actions'
import backend from '../../backend'
import {
  AUTH_DEBUG_VIEW_UPDATING, AUTH_MANAGER_RESTRICTED_UPDATING,
  AUTH_PROFILE_UPDATING,
  AUTH_STATUS_SETTING,
  AUTH_USER_ADMIN_UPDATING,
  AUTH_USER_ROLE_UPDATING
} from '../mutations'
import router from '../../router'

import { getField } from 'vuex-map-fields'
import { USER_STATISTICS_MODULE } from '../modules'

const getDefaultState = () => ({
  auth: false,
  profilePicture: '',
  email: '',
  username: '',
  isSpecial: false,
  isAdmin: false,
  isDebugView: false,
  isManagerRestricted: false,
})

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    [AUTH_PROFILE_UPDATING] (state, payload = { profile_picture: '', email: '', username: '' }) {
      state.profilePicture = payload.profile_picture
      state.email = payload.email
      state.username = payload.username
    },
    [AUTH_STATUS_SETTING] (state, payload) {
      state.auth = payload
    },
    [AUTH_USER_ROLE_UPDATING] (state, payload) {
      state.isSpecial = payload
    },
    [AUTH_USER_ADMIN_UPDATING] (state, payload) {
      state.isAdmin = payload
    },
    [AUTH_DEBUG_VIEW_UPDATING] (state, payload) {
      state.isDebugView = payload
    },
    [AUTH_MANAGER_RESTRICTED_UPDATING] (state, payload) {
      state.isManagerRestricted = payload
    }
  },
  actions: {
    async [AUTH_LOGIN] (context, params = {}) {
      try {
        const code = await this._vm.$gAuth.getAuthCode()
        const result = await backend.googleLogin({ code })
        if (result.status === 200) {
          // we can get profile data and set auth
          context.commit(AUTH_PROFILE_UPDATING, result.data)
          context.commit(AUTH_STATUS_SETTING, true)

          await router.push({ name: 'panelMap' }).catch(() => {
            if (process.env.VUE_APP_HIDDEN_MODE) {
              router.go()
            }
          })
        }
      } catch (e) {
        console.error(e)
        context.commit(AUTH_PROFILE_UPDATING)
        context.commit(AUTH_STATUS_SETTING, false)
      }
    },
    async [AUTH_LOGOUT] (context) {
      try {
        await backend.logout()
      } catch (e) {
        console.error(e)
      } finally {
        context.commit(AUTH_PROFILE_UPDATING)
        context.commit(AUTH_STATUS_SETTING, false)

        // clear user statistics
        context.dispatch(`${USER_STATISTICS_MODULE}/${CLEAR_MODULE_STATE}`, {}, { root: true })

        if (!process.env.VUE_APP_HIDDEN_MODE) {
          await router.push({ name: 'home' })
        }

      }
    },
    [UPDATE_USER_ROLE] (context, isSpecial) {
      if (!('isSpecial' in context.state) || context.state.isSpecial !== isSpecial) {
        context.commit(AUTH_USER_ROLE_UPDATING, isSpecial)
      }
    },
    [UPDATE_ADMIN_ROLE] (context, isAdmin) {
      if (!('isAdmin' in context.state) || context.state.isAdmin !== isAdmin) {
        context.commit(AUTH_USER_ADMIN_UPDATING, isAdmin)
      }
    },
    [UPDATE_DEBUG_VIEW] (context, isDebugView) {
      if (!('isDebugView' in context.state) || context.state.isDebugView !== isDebugView) {
        context.commit(AUTH_DEBUG_VIEW_UPDATING, isDebugView)
      }
    },
    [UPDATE_MANAGER_RESTRICTED] (context, isManagerRestricted) {
      if (!('isManagerRestricted' in context.state) || context.state.isManagerRestricted !== isManagerRestricted) {
        context.commit(AUTH_MANAGER_RESTRICTED_UPDATING, isManagerRestricted)
      }
    },
    [UPDATE_USER_PROFILE] (context, profile) {
      context.commit(AUTH_PROFILE_UPDATING, profile)
    }
  },
  getters: {
    getField
  }
}
